(function (root, factory) {
  const story = factory();
  if (typeof module === "object" && module.exports) module.exports = story;
  if (root) root.LafiaConceptStory = story;
})(typeof window === "undefined" ? null : window, function () {
  "use strict";

  const FORMAT = "lafia-story-v1";
  const LANG = { ko: "kr", kr: "kr", en: "en", ja: "jp", jp: "jp" };

  function select(description, requested) {
    const desc = description && typeof description === "object" ? description : {};
    const wanted = LANG[requested] || "kr";
    const hasOwn = Object.prototype.hasOwnProperty.call(desc.storyLine || {}, wanted);
    const selected = hasOwn ? wanted : "kr";
    const get = (field) => String(desc[field] && desc[field][selected] || "");
    const format = desc.storyFormat && desc.storyFormat[selected];
    return {
      mode: format === FORMAT ? "v1" : "legacy",
      locale: selected === "jp" ? "ja" : selected === "kr" ? "ko" : "en",
      title: get("title"),
      subTitle: get("subTitle"),
      body: get("storyLine"),
      closing: get("closing"),
    };
  }

  function parse(body) {
    const input = String(body || "").replace(/\r\n?/g, "\n");
    if (input.length > 32000) throw new Error("story-too-long");
    const paragraphs = input.split(/\n\s*\n/).map((part) => part.trim()).filter(Boolean);
    if (paragraphs.length > 300) throw new Error("too-many-paragraphs");
    return paragraphs.map((paragraph) => {
      const lines = paragraph.split("\n");
      const quoted = lines.every((line) => /^> /.test(line));
      const content = quoted ? lines.map((line) => line.slice(2)).join("\n") : paragraph;
      const parts = [];
      let cursor = 0;
      const marker = /\*\*/g;
      let strong = false;
      let match;
      while ((match = marker.exec(content))) {
        if (match.index > 0 && content[match.index - 1] === "\\") continue;
        if (match.index > cursor) parts.push({ text: content.slice(cursor, match.index), strong });
        strong = !strong;
        cursor = match.index + 2;
      }
      if (strong) throw new Error("unclosed-emphasis");
      if (cursor < content.length) parts.push({ text: content.slice(cursor), strong: false });
      return { quoted, parts };
    });
  }

  function plainText(body) {
    try {
      return parse(body).map((block) => block.parts.map((part) => part.text.replace(/\\\*\*/g, "**")).join("")).join("\n\n");
    } catch {
      return String(body || "");
    }
  }

  function appendText(target, text) {
    const lines = text.replace(/\\\*\*/g, "**").split("\n");
    lines.forEach((line, index) => {
      if (index) target.appendChild(document.createElement("br"));
      target.appendChild(document.createTextNode(line));
    });
  }

  function render(target, selected) {
    if (!target) return;
    target.replaceChildren();
    if (!selected || selected.mode !== "v1" || !selected.body.trim()) {
      target.hidden = true;
      return;
    }
    target.hidden = false;
    target.classList.add("lafia-story");
    target.lang = selected.locale;
    if (selected.title) {
      const title = document.createElement("h2");
      title.className = "lafia-story__title";
      title.id = "storyTitle";
      title.textContent = selected.title;
      target.appendChild(title);
    }
    if (selected.subTitle) {
      const subtitle = document.createElement("p");
      subtitle.className = "lafia-story__subtitle";
      subtitle.textContent = selected.subTitle;
      target.appendChild(subtitle);
    }
    const body = document.createElement("div");
    body.className = "lafia-story__body";
    let blocks;
    try { blocks = parse(selected.body); }
    catch (error) {
      console.error("Invalid concept story format", error);
      blocks = [{ quoted: false, parts: [{ text: selected.body, strong: false }] }];
    }
    blocks.forEach((block) => {
      const paragraph = document.createElement(block.quoted ? "blockquote" : "p");
      paragraph.className = block.quoted ? "lafia-story__quote" : "lafia-story__paragraph";
      if (!block.quoted && block.parts.length && block.parts.every((part) => part.strong || !part.text.trim())) {
        paragraph.classList.add("lafia-story__statement");
      } else if (!block.quoted && block.parts[0]?.strong && /^\n/.test(block.parts[1]?.text || "")) {
        paragraph.classList.add("lafia-story__lead");
      }
      block.parts.forEach((part) => {
        const node = part.strong ? document.createElement("strong") : paragraph;
        appendText(node, part.text);
        if (part.strong) paragraph.appendChild(node);
      });
      body.appendChild(paragraph);
    });
    target.appendChild(body);
    if (selected.closing) {
      const closing = document.createElement("p");
      closing.className = "lafia-story__closing";
      closing.textContent = selected.closing;
      target.appendChild(closing);
    }
  }

  return { FORMAT, select, parse, plainText, render };
});
